module.exports = __webpack_public_path__ + "ru-src-icon.png?e89dd56cd71b55abb224d5f88f30a4c3";